/*
 * $Id:: FilterChips.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React from 'react';

import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as CancelIcon } from '../../assets/images/cancel_icon.svg';
import { bareDateTimeFormat, t } from '../../providers';

const useStyles = makeStyles((theme) => ({
    filters: {
        display: 'flex',
        flexFlow: 'row wrap',
        alignItems: 'center',
    },
    filterLabel: {
        fontSize: '14px',
        fontWeight: '600',
        color: theme.palette.text.tableValue,
        marginRight: '6px',
    },
    filterItem: {
        marginRight: '12px',
    },
    clearButton: {
        color: theme.palette.text.mainBlue,
        margin: '0',
        '& path': {
            fill: theme.palette.text.mainBlue,
        },
    },
    clearText: {
        marginLeft: '5px',
    },
}));

const FilterChips = ({ filteredBy, onClearFilters }) => {
    const classes = useStyles();

    const addNiceClass = (str) => `${t('filter.nice.class')} ${str}`;
    const addLocarnoClass = (str) => `${t('filter.locarno.class')} ${str}`;
    const filters = Object.keys(filteredBy || {}).reduce((acc, cur) => {
        if (cur === 'searchQuery') {
            return acc;
        }

        let filts;
        if (cur === 'classes') {
            filts = filteredBy[cur].map(addNiceClass);
        } else if (cur === 'locarno') {
            filts = addLocarnoClass(filteredBy[cur]);
            return [...acc, filts];
        } else if (cur === 'ipRightType') {
            filts = t(filteredBy[cur]);
            return [...acc, filts];
        } else if (cur === 'dates') {
            filts = filteredBy[cur].filter((dr) => !!dr.dateType && !!dr.startDate && !!dr.endDate);
            if (!filts.length) {
                return acc;
            }
            return [
                ...acc,
                ...filts.map(
                    (dr) =>
                        `${t(dr.dateTypeLabel)} (${t('from')} ${bareDateTimeFormat(dr.startDate, 'dd/mm/YY')} - ${t('to')} ${bareDateTimeFormat(
                            dr.endDate,
                            'dd/mm/YY'
                        )})`
                ),
            ];
        } else if (cur === 'requiresReply') {
            filts = filteredBy[cur].map((item) => (item === 'correspondence.filter.reply.yes' ? t('reply.needed') : t('no.reply.needed')));
        } else if (cur === 'important') {
            filts = filteredBy[cur].map((item) => (item === 'correspondence.filter.important.yes' ? t('correspondence.filter.chip.important.yes') : t('correspondence.filter.chip.important.no')));
        } else {
            filts = filteredBy[cur].map((fil) => t(fil));
        }

        return [...acc, ...(filts || [])];
    }, []);

    return (
        filters.length && (
            <div className={classes.filters}>
                <InputLabel className={classes.filterLabel}>{t('filtered.by')}:</InputLabel>
                {(filters || []).map((flt, idx) => (
                    <span key={`${flt}_${idx}`} className={classes.filterItem}>
                        {`${flt}${idx !== filters.length - 1 ? ',' : ''}`}
                    </span>
                ))}
                <Button className={classes.clearButton} onClick={onClearFilters}>
                    <CancelIcon />
                    <span className={classes.clearText}>{t('clear')}</span>
                </Button>
            </div>
        )
    );
};

export default FilterChips;
